import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  menu: {
    flex: "0 0 190px",
    borderRight: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.5, 1),
    overflowY: "auto",
  },
  item: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.25),
    width: "100%",
    border: "none",
    background: "transparent",
    font: "inherit",
    color: theme.palette.text.secondary,
    textAlign: "left",
    padding: theme.spacing(1.1, 1.25),
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 13.5,
    marginBottom: 2,
    transition: "background 0.15s ease, color 0.15s ease",
    "&:hover": { background: theme.palette.action.hover, color: theme.palette.text.primary },
  },
  itemActivo: {
    background: theme.palette.action.selected,
    color: theme.palette.text.primary,
    fontWeight: 600,
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 8,
      bottom: 8,
      width: 3,
      borderRadius: 3,
      background: theme.palette.primary.main,
    },
  },
}));

const ConnectionModalSidebar = ({ tabs, active, onChange }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.menu}>
      {tabs.map((t) => (
        <button
          key={t.value}
          type="button"
          className={cx(classes.item, active === t.value && classes.itemActivo)}
          onClick={() => onChange(t.value)}
        >
          {t.icon}
          {t.label}
        </button>
      ))}
    </div>
  );
};

export default ConnectionModalSidebar;
